import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { updateOutputQuery } from 'actions/feature/outputs'
import { getAvailableLogicNodesMeta } from 'selectors/feature/logicNodes'
import {
  makeGetOutputQuery,
  getOutputQueryDescription,
} from 'selectors/feature/outputs'
import { getIsOneOutputQueryDefined } from 'selectors/feature/features'
import OutputQuery from './OutputQuery'

const makeMapStateToProps = () => {
  const getOutputQuery = makeGetOutputQuery()

  return (state, ownProps) => {
    const { fnId, id } = ownProps
    const validUris = getAvailableLogicNodesMeta(state, { id })
    const outputQuery = getOutputQuery(state, { fnId })
    const { uri } = outputQuery || {}

    const outputQueryDescription = getOutputQueryDescription(state, {
      fnId,
      id,
    })
    const isOneOutputQueryDefined = getIsOneOutputQueryDefined(state)

    return {
      fnId,
      id,
      validUris,
      uri,
      outputQueryDescription,
      isOneOutputQueryDefined,
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { fnId } = ownProps

  return {
    ...bindActionCreators(
      {
        updateOutputQuery: (uri) => updateOutputQuery(uri, fnId),
      },
      dispatch
    ),
  }
}

const OutputQueryContainer = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(OutputQuery)

export default OutputQueryContainer
